import React from 'react';
import { ExternalLink, Mail } from 'lucide-react';

const FIXELS_LOGO = "https://res.cloudinary.com/dpa295hyx/image/upload/v1766078478/Fixels_White_2_gogp2y.png";

interface FixelsBadgeProps {
  className?: string;
  variant?: 'default' | 'minimal';
}

export const FixelsBadge: React.FC<FixelsBadgeProps> = ({ className = "", variant = 'default' }) => (
  <a 
    href="https://fixels.nl" 
    target="_blank" 
    rel="noopener noreferrer"
    className={`group inline-flex items-center gap-2.5 px-3 py-1.5 bg-slate-900/90 backdrop-blur-md border border-slate-700/50 rounded-full hover:bg-slate-800 hover:shadow-lg hover:shadow-brand-900/10 transition-all duration-300 ${className}`}
  >
    <span className="text-[9px] uppercase tracking-[0.2em] text-slate-400 font-medium group-hover:text-slate-300 transition-colors pt-0.5">
      Made by
    </span>
    <img 
      src={FIXELS_LOGO} 
      alt="Fixels" 
      className="h-3 w-auto opacity-80 group-hover:opacity-100 transition-all duration-300" 
    />
  </a>
);

export const FixelsHint: React.FC = () => {
  return (
    <div className="mt-12 pt-8 border-t border-slate-100/80">
      <div className="flex flex-col items-center text-center">
        <p className="text-slate-400 text-xs font-medium mb-4 tracking-wide uppercase">
          Ook geïnteresseerd in een platform als dit?
        </p>
        
        <div className="flex flex-wrap items-center justify-center gap-3 mb-6">
          <a 
            href="https://fixels.nl" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-medium text-slate-600 hover:text-brand-700 transition-colors flex items-center gap-1.5 px-4 py-2 rounded-lg hover:bg-slate-50 border border-transparent hover:border-slate-200"
          >
            <ExternalLink size={14} />
            Bekijk Fixels
          </a>
          <a 
            href="mailto:contact@fixels.nl"
            className="text-xs font-medium text-slate-600 hover:text-brand-700 transition-colors flex items-center gap-1.5 px-4 py-2 rounded-lg hover:bg-slate-50 border border-transparent hover:border-slate-200"
          >
            <Mail size={14} />
            Contact
          </a>
        </div>

        <FixelsBadge />
      </div>
    </div>
  );
};